// Phase H.10 — `fontSize` attribute on TextStyle.
//
// TipTap v3 does not ship an official `@tiptap/extension-font-size` package
// for v3 (only v2 had it). The recommended path is to extend TextStyle with a
// `fontSize` attribute. Marks the run with `<span style="font-size: 14pt">`
// which our PDF renderer already honors via inline CSS.

import { Extension } from "@tiptap/core";
import "@tiptap/extension-text-style";

export const FontSize = Extension.create({
    name: "fontSize",

    addOptions() {
        return { types: ["textStyle"] };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (el) =>
                            el.style.fontSize || null,
                        renderHTML: (attrs) => {
                            if (!attrs.fontSize) return {};
                            return {
                                style: `font-size: ${attrs.fontSize}`,
                            };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontSize:
                (size) =>
                ({ chain }) =>
                    chain().setMark("textStyle", { fontSize: size }).run(),
            unsetFontSize:
                () =>
                ({ chain }) =>
                    chain()
                        .setMark("textStyle", { fontSize: null })
                        .removeEmptyTextStyle()
                        .run(),
        };
    },
});

export default FontSize;
